module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "toast",
    class: {
      'show': _vm.isShow
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.msg))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9fd28070"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v_toast/index.vue
// module id = 606
// module chunks = 1